<template>
    <div>
        <a :href="matchCentreUrl" class="btn btn-live" :class="!live ? 'disable' : ''">LIVE</a>
    </div>
</template>

<script>
import {mapState} from 'vuex'


export default {
    data() {
        return {
            live: null,
        }
    },

    props: [
        'url', 'matchCentreUrl'
    ],


    computed: {
    },

    created() {
    },

    mounted() {
        var self = this;
        self.checkLive();
        setInterval(() => {
            self.checkLive();
        }, 60000);
    },

    watch: {
    },

    methods: {
        checkLive() {
            var self = this 
            var url = this.url + '/storage/isLive.json'
            $.getJSON(url, function(data) {
                self.live = data.isLive;
            });
        }
    },
}
</script>
